// algoritmoTesteServices.js
import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useAlgoritmoTesteService() {
  const { authenticatedFetch } = useApi();

  // --------- CREATE
  // aceita { testeId, titulo, algoritmo, versao?, status?, publishExclusive?, isCurrent? }
  const criarAlgoritmo = async (dados) => {
    const res = await authenticatedFetch(URLS.TESTE_ALGORITMO_CREATE, {
      method: 'POST',
      body: JSON.stringify(dados),
    });
    return res.json();
  };

  // --------- UPDATE
  // aceita campos parciais { id, testeId?, titulo?, algoritmo?, versao?, status?, publishedAt?, isCurrent? }
  const atualizarAlgoritmo = async (dados) => {
    const res = await authenticatedFetch(URLS.TESTE_ALGORITMO_UPDATE, {
      method: 'POST',
      body: JSON.stringify(dados),
    });
    return res.json();
  };

  // --------- DELETE
  // id (codificado)
  const deletarAlgoritmo = async (id) => {
    const res = await authenticatedFetch(URLS.TESTE_ALGORITMO_DELETE, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });
    return res.json();
  };

  // --------- READ (coleção)
  const listarAlgoritmos = async ({ limit = 100, offset = 0 } = {}) => {
    const qs = new URLSearchParams({ limit, offset }).toString();
    const res = await authenticatedFetch(`${URLS.TESTE_ALGORITMO_LIST}?${qs}`);
    return res.json();
  };

  // --------- READ (por id)
  // id (codificado)
  const obterAlgoritmoPorId = async (id) => {
    const qs = new URLSearchParams({ id }).toString();
    const res = await authenticatedFetch(`${URLS.TESTE_ALGORITMO_GET}?${qs}`);
    return res.json();
  };

  // --------- READ (por teste, com filtros)
  const listarAlgoritmosPorTeste = async ({ testeId, status = null, limit = 100 }) => {
    if (typeof testeId === 'undefined' || testeId === null || testeId === '') {
      console.warn('[listarAlgoritmosPorTeste] testeId ausente/ inválido:', testeId);
    }
    const params = new URLSearchParams();
    if (typeof testeId !== 'undefined') params.set('testeId', String(testeId));
    if (limit != null) params.set('limit', String(limit));
    if (status) params.set('status', status);

    const url = `${URLS.TESTE_ALGORITMO_LIST_BY_TESTE}?${params.toString()}`;
    console.log('[listarAlgoritmosPorTeste] GET', url);
    const res = await authenticatedFetch(url);
    const json = await res.json();
    console.log('[listarAlgoritmosPorTeste] ← response:', json);
    return json;
  };

  // --------- READ helpers
  // testeId (codificado)
  const obterUltimoPublicadoPorTeste = async (testeId) => {
    const qs = new URLSearchParams({ testeId }).toString();
    const res = await authenticatedFetch(`${URLS.TESTE_ALGORITMO_GET_LATEST_PUBLISHED}?${qs}`);
    return res.json();
  };

  // testeId (codificado)
  const obterUltimoRascunhoPorTeste = async (testeId) => {
    const qs = new URLSearchParams({ testeId }).toString();
    const res = await authenticatedFetch(`${URLS.TESTE_ALGORITMO_GET_LATEST_DRAFT}?${qs}`);
    return res.json();
  };

  // testeId (codificado) — versão vigente (is_current=1)
  const obterAlgoritmoVigentePorTeste = async (testeId) => {
    const qs = new URLSearchParams({ testeId }).toString();
    const res = await authenticatedFetch(`${URLS.TESTE_ALGORITMO_GET_CURRENT}?${qs}`);
    return res.json();
  };

  // --------- Ações (publish/archive/current/clone)

  // Publica (sem mexer no "current")
  const publicarAlgoritmo = async (id) => {
    const res = await authenticatedFetch(URLS.TESTE_ALGORITMO_PUBLISH, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });
    return res.json();
  };

  // Arquiva
  const arquivarAlgoritmo = async (id) => {
    const res = await authenticatedFetch(URLS.TESTE_ALGORITMO_ARCHIVE, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });
    return res.json();
  };

  // Marca como vigente (is_current=1) de forma exclusiva
  // requer { id (codificado), testeId (codificado) }
  const marcarComoVigenteExclusivo = async ({ id, testeId }) => {
    const res = await authenticatedFetch(URLS.TESTE_ALGORITMO_SET_CURRENT, {
      method: 'POST',
      body: JSON.stringify({ id, testeId }),
    });
    return res.json();
  };

  // Publica e já marca como vigente (transação única)
  // requer { id (codificado), testeId (codificado) }
  const publicarEAtivarAlgoritmo = async ({ id, testeId }) => {
    const res = await authenticatedFetch(URLS.TESTE_ALGORITMO_PUBLISH_AND_SET_CURRENT, {
      method: 'POST',
      body: JSON.stringify({ id, testeId }),
    });
    return res.json();
  };

  // Clonar como draft
  // requer { sourceId (codificado), newVersao, novoTitulo? }
  const clonarAlgoritmoComoDraft = async ({ sourceId, newVersao, novoTitulo = null }) => {
    const res = await authenticatedFetch(URLS.TESTE_ALGORITMO_CLONE, {
      method: 'POST',
      body: JSON.stringify({ sourceId, newVersao, novoTitulo }),
    });
    return res.json();
  };

  return {
    // CRUD
    criarAlgoritmo,
    atualizarAlgoritmo,
    deletarAlgoritmo,
    listarAlgoritmos,
    obterAlgoritmoPorId,
    listarAlgoritmosPorTeste,
    obterUltimoPublicadoPorTeste,
    obterUltimoRascunhoPorTeste,
    obterAlgoritmoVigentePorTeste,

    // Ações
    publicarAlgoritmo,
    arquivarAlgoritmo,
    marcarComoVigenteExclusivo,
    publicarEAtivarAlgoritmo,
    clonarAlgoritmoComoDraft,
  };
}